import type { IntlShape } from 'react-intl';

import { DateUtil } from '@src/packages/utils/dates';

export const formatCoverDrawerTitle = (
  journeyName: string | undefined,
  dateParam: string,
  _intl: IntlShape,
): string => {
  // Calendar ISO dates must not go through intl.formatDate (UTC midnight →
  // previous local day in Chile). Match the attention table formatter.
  const dateLabel = dateParam
    ? DateUtil.toDateString(dateParam, DateUtil.DEFAULT_DT_DATE_FORMAT)
    : '';
  const safeDateLabel = dateLabel && dateLabel !== '-' ? dateLabel : '';

  if (safeDateLabel && journeyName) {
    return `${journeyName} - ${safeDateLabel}`;
  }

  return journeyName || safeDateLabel || dateParam || '';
};
